import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../../../../context/AppContext";
import UserPageLayout from "../../../../components/UserPageLayout";
import AnnouncementList from "../../components/AnnouncementList";
import AnnouncementForm from "../../components/AnnouncementForm";

export default function AnnouncementsAdmin() {
    const { setPageTitle, setPageUserID, userAccessData } = useAppContext();
    const [editMode, setEditMode] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

    const canManageAnnouncements = Boolean(userAccessData?.super_user && userAccessData?.trusted_user);

    useEffect(() => {
        setPageUserID(null);
        setPageTitle(editMode ? "Announcement Editor" : "Announcements");
    }, [editMode, setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {!editMode ? (
                                <AnnouncementList
                                    setEditMode={setEditMode}
                                    setSelectedAnnouncement={setSelectedAnnouncement}
                                    selectedAnnouncement={selectedAnnouncement}
                                    canManageAnnouncements={canManageAnnouncements}
                                />
                            ) : (
                                <AnnouncementForm
                                    setEditMode={setEditMode}
                                    selectedAnnouncement={selectedAnnouncement}
                                    canManageAnnouncements={canManageAnnouncements}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}
